var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Info',{attrs:{"courseInfo":_vm.courseInfo,"getData":_vm.getCourseInfo}}),_c('Lesson'),_c('Student',{attrs:{"courseId":_vm.courseId,"orgId":_vm.orgId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }